import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProjectDetailCoaGridPage } from './project-detail-coa-grid';
import { BodyModule, GridModule, SharedModule } from '@progress/kendo-angular-grid';
import { PtKendoModule } from '../../../../_foundation/kendo/modules/pt.kendo.module';

@NgModule({
  declarations: [
    ProjectDetailCoaGridPage,
  ],
  imports: [
    IonicPageModule.forChild(ProjectDetailCoaGridPage),
    GridModule,
    SharedModule,
    BodyModule,
    PtKendoModule
  ],
})
export class ProjectDetailCoaGridPageModule {}



// WEBPACK FOOTER //
// ./src/pages/setup/project-details/project-detail-coa-grid/project-detail-coa-grid.module.ts